<h1 mat-dialog-title>Asset Detail</h1>
<mat-divider></mat-divider>

<mat-dialog-content>
  <div class="row">
      <span class="label">Id</span>
      <span class="value">{{ asset.id }}</span>
  </div>
  <div class="row">
      <span class="label">Name</span>
      <span class="value">{{ asset.properties.optionalValue('edc','name') }}</span>
  </div>
  <div class="row">
      <span class="label">Type</span>
      <span class="value">{{ getOptionalValue(asset.properties["http://purl.org/dc/terms/type"])}}</span>
  </div>
  <div class="row">
      <span class="label">Content Type</span>
      <span class="value">{{ asset.properties.optionalValue('edc','contenttype') }}</span>
  </div>
  <div class="row">
      <span class="label">Version</span>
      <span class="value">{{ asset.properties.optionalValue('edc','version') }}</span>
  </div>
  <div class="row">
      <span class="label">BaseUrl</span>
      <span class="value">{{ asset.dataAddress.optionalValue('edc','baseUrl') }}</span>
  </div>
  <div class="row">
      <span class="label">Destination</span>
      <span class="value">{{ asset.dataAddress.optionalValue('edc','type') }}</span>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button color="accent" mat-dialog-close mat-stroked-button>
      <mat-icon>cancel</mat-icon> Cancel
  </button>
</mat-dialog-actions>
